module.exports = "/images/modal-success-icon.svg?c8eb9a49e7f5bd0081675d4145f5fc37";